import { Types } from "./types";

const initialState = {
    dataMerchantHNG: {
        rows: [],
        paging: {}
    },
    dataUsersMerchantHNG: {
        rows: [],
        paging: {}
    },
    dataRequestMerchant: {
        rows: [],
        paging: {}
    },
    dataConfig: []
}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_MERCHANT_HNG:
            return {
                ...newState,
                dataMerchantHNG: action.payload
            }
        case Types.SAVE_LIST_REQUEST_MERCHANT:
            return {
                ...newState,
                dataRequestMerchant: action.payload
            }
        case Types.SAVE_LIST_USER_MERCHANT_HNG:
            return {
                ...newState,
                dataUsersMerchantHNG: action.payload
            }
        case Types.SAVE_CONFIG_MERCHANT_HNG:
            return {
                ...newState,
                dataConfig: action.payload
            }
        default:
            return { ...newState }
    }
}
export default reducer
